import { Injectable } from "@angular/core";
import { HttpParams } from "@angular/common/http";

import { Observable, take } from "rxjs";

import { HttpBaseService } from "../http/http-base.service";
import { Tag } from "../../models/core/tag.interface";
import { DEFAULT_PAGINATION, Pagination } from "../../models/pagination.interface";
import { PaginatedResponse } from "../../models/paginated-response.interface";
import { sharedEnvironment } from "../../../environments/shared-environment";

@Injectable({
  providedIn: "root"
})
export class TagsService extends HttpBaseService {
  protected override getApiEndpoint(): string[] {
    return [sharedEnvironment.serviceUrl, "api", "content/tag"];
  }

  public getTagFilterList(
    filters = "",
    sorts = "",
    pagination: Pagination = DEFAULT_PAGINATION
  ): Observable<PaginatedResponse<Tag>> {
    const params = new HttpParams()
      .set("filters", filters)
      .set("sorts", sorts)
      .set("page", pagination.pageNumber.toString())
      .set("pageSize", pagination.pageSize.toString());

    return this.http.get<PaginatedResponse<Tag>>(this.buildPath(), { params }).pipe(take(1));
  }

  public createTag(txTag: string): Observable<Tag> {
    return this.http.post<Tag>(this.buildPath(), { txTag }).pipe(take(1));
  }

  // DEV-808: exclui a tag permanentemente (backend remove os vínculos com coleções/itens).
  public deleteTag(idTag: string): Observable<void> {
    return this.http.delete<void>(this.buildPath([idTag])).pipe(take(1));
  }
}
